import api from "./api";

export const getAlarmStatus = async () => {
    const response = await api.get(`alarmStatus/listSomeAlarmStatus`);
    return response.data;
};